whenAvailable('$', function() {
$(function(){
    // Countdown Timers
    var $countdown = $('#quiccs_countdown');
    if ($countdown.length) {
        whenAvailable('showTimer', function() {
            $countdown.showTimer({returnType: "box", wrapper_id: "counter_wrapper", local_l_hrs: "HOURS", local_l_min: "MINUTES", local_l_sec: "SECONDS", timeZone: '+08:00'});
        });
    }

    // Redemption Form
    const $form = $('#redeemForm'),
          $formFields = $('#redeemForm input:not([type=hidden]), #redeemForm select'),
          $formSubmit = $('#submitForm');

    $('#redeem_btn').click(function(){
        $('.redemption-step1').hide();
        $('.redemption-step2').fadeIn();
    });

    $formFields.on('change', function(){
        if (this.id == 'store_code') {
            if (this.value.length > 0) {
                var order_no;
                if ( this.value == 'SG' ) {
                    order_no = '0020000S';
                } else if ( this.value == 'US' ) {
                    order_no = '03000000US';
                } else if ( this.value == 'PH' ) {
                    order_no = '';
                    $('.form-mobile').show();
                    $('#extra_1').prop('disabled', false);
                }
                $('#redeemForm #shopify_order_name').prop('disabled', false).attr('placeholder', order_no);
            }
        } else if (this.id == 'shopify_order_name') {
            var country = $('#redeemForm #store_code').val();
            if (country != 'PH') {
                _this = $(this);
                $.post('https://beans.secretlab.co/index.php/api/2019-08/'+shop_locale+'/verify_order_no/', {
                    order_no:     _this.val(),
                    country_code: country,
                    link_shopify: 'Y',
                    store_type:   'secretlab'
                }, function (data) {
                    if ('ok' === data.status) {
                        _this.removeClass('is-invalid');
                        _this.get(0).setCustomValidity('');
                    } else {
                        _this.addClass('is-invalid').focus();
                        _this.get(0).setCustomValidity('Please provide a valid order number.');
                    }
                }, 'json');
            }
        }
    })

    $formSubmit.on('click', function(){
        $.validateForm('#redeemForm');
    });

    $form.submit(function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        $.submitForm('https://beans.secretlab.co/index.php/api/api_campaign_participate', formData, $form);
    });
});
});
